/*-----------------------------------------------------------------------------/
/ Custom Theme JS = Has been added by Sam
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
    var text_max = $('#Cart-note').attr('maxlength');
    $('#Cart-note_feedback').html(text_max + ' characters remaining');

    $('#Cart-note').keyup(function() {
        var text_length = $('#Cart-note').val().length;
        var text_remaining = text_max - text_length;
        $('#Cart-note_feedback').html(text_remaining + ' characters remaining');
    });
});
$(window).on("drawer_open_done", function() {
				if (window.Zapiet && window.ZapietCachedSettings) {
				  Zapiet.start(ZapietCachedSettings);
				}
			 });
			
			$(window).on("cart_update_done", function() {
			  if (window.Zapiet && window.ZapietCachedSettings) {
				Zapiet.start(ZapietCachedSettings);
			  }
			});


//Table Search Functionality // 


function myFunction() {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}
function myFunction2() {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput2");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[1];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}

/*-----------------------------------------------------------------------------/
/ End Additions by Sam
/-----------------------------------------------------------------------------*/